"use client";

import { BlogPost, filterPostsByLanguage } from "../data/blog-posts";
import { BlogCard } from "./blog-card";
import { useTranslation } from "@/lib/hooks/use-translation";

type BlogGridProps = {
  posts: BlogPost[];
};

export function BlogGrid({ posts }: BlogGridProps) {
  const { t, language } = useTranslation();
  const visible = filterPostsByLanguage(posts, language);

  if (visible.length === 0) {
    return (
      <p className="text-base font-medium leading-7 text-black/60">
        {t("blogPage.empty")}
      </p>
    );
  }

  return (
    <section
      aria-label={t("blogPage.allPosts")}
      // `auto-rows-fr` equalises the rows against each other, not just the
      // cards within a row: posts with a second line of tags used to make their
      // row ~60px taller than its neighbours, so the grid read as ragged even
      // though each row was internally consistent.
      className="grid auto-rows-fr grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3"
    >
      {visible.map((post, index) => (
        <BlogCard key={post.id} post={post} priority={index < 3} />
      ))}
    </section>
  );
}
